import {Skeleton} from "@project/design-system-web";

export function TabsSkeleton({tabs = 3}: {tabs?: number}) {
  return (
    <div className="flex w-full @2xl:mx-0 @2xl:justify-center @2xl:px-0">
      <div className="flex w-fit items-center gap-2 px-2 py-1">
        {Array.from({length: tabs}).map((_, i) => (
          <Skeleton key={i} className="h-8 w-24 rounded-full" />
        ))}
      </div>
    </div>
  );
}
